import React, { useEffect, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Form, Input, Spin, Modal, Row, Select, Pagination } from 'antd';
import {  AiOutlineSearch, AiOutlineSync ,AiOutlineFileAdd ,AiFillEye,AiOutlineCloseCircle} from 'react-icons/ai';
import MessageCommon from '../../enum/Message';
import { Label } from 'reactstrap';
import RemoveCartonModalCollect from './RemoveCartonModalCollect';
import RemoveCartonModalStorage from './RemoveCartonModalStorage';
import { Parameter,CartonList,Item, User} from '../../models'
import { Helper, InitHelper } from '../../helpers';
import { StorageCartonService, CollectCartonService,HrWebService } from '../../services';
import dayjs from 'dayjs'
import {  CartonStatus, UserRole } from '../../enum'
import { EmployeeAutoComplete } from '../../autocomplete/EmployeeAutoComplete'
import CollectCartonRequestDetail from '../CollectCarton/CollectCartonRequestDetail';
import StorageCartonRequestDetail from '../StorageCarton/StorageCartonRequestDetail';
import secureLocalStorage from "react-secure-storage";
import { apiRequest } from "../../configurations/authConfig";
import { useMsal } from "@azure/msal-react";

interface AppState {
  currentPage:number
  perpage:number
  total: number
  items:CartonList[]
  itemNoList:string[]
  isLoading:boolean
}

interface Props {
    requestTypeId:number
    onSelect:any
    items:CartonList[]
  }

const RemoveCartonAdd = (props:Props) => {
    const { instance, accounts } = useMsal();
    const userStore = secureLocalStorage.getItem('user')
    const user:User = userStore ? JSON.parse(userStore.toString()): null
    const pageSizeOptions = user.systemConfig.tablePageSize
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataForm] = Form.useForm();
  const { Panel } = Collapse;
  const [modal, contextHolder] = Modal.useModal();
  const [selectItems, setSelectItems] = useState<string[]>([])
  const [isModalRequestOpen, setIsModalRequestOpen] = useState(false);
  const [requestTypeId,setRequestTypeId] = useState(props.requestTypeId)
  const [requestTypeId2,setRequestTypeId2] = useState(props.requestTypeId)
  const [documentStartYear, setDocumentStartYear] = useState<number|null|undefined>(undefined);
  const [documentEndYear, setDocumentEndYear] = useState<number|null|undefined>(undefined);
  const [saveParameter,setSaveParameter] = useState<Parameter>(InitHelper.InitialParameter)
  const [recordNo,setRecordNo] = useState(0)
  const [requesters, setRequesters] = useState<Item[]>([])
  const [owners, setOwners] = useState<Item[]>([])
  const [appState,setAppState] = useState<AppState>({
    currentPage : 1,
    total : 0,
    perpage: 10,
    items: [],
    itemNoList:[],
    isLoading : true
  })
  const [requestStartDate, setRequestStartDate] = useState<Date|null>(null);
  const [requestEndDate, setRequestEndDate] =  useState<Date|null>(null);

  useEffect(() => {
    initial()

  }, [])

  const initial = () => {
      setSelectItems([])
      let parameter = InitHelper.InitialParameter()
      parameter.requesters = []
      parameter.owners = []
      parameter.requesterOrgUnit = user.orgUnit
      parameter.employeeLevel = user.level
      parameter.userConfidential = user.employeeId
      getData(1, appState.perpage,parameter)
  }

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const layout = {
    labelCol: { lg: 6 },
    wrapperCol: { lg: 18 }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOpenModalRequest = async (_recordNo:number) => {
    setRecordNo(_recordNo)
    setIsModalRequestOpen(true)
  
  }

  const handleCancelModalRequest = () => {
    setIsModalRequestOpen(false)
  }

  
  const onCheckAll = (e:React.ChangeEvent<HTMLInputElement>) => {
    let items:string[] = []
    if(e.target.checked){
      appState.items.forEach(item => {
        let element = document.getElementById('check-item-' + item.cartonNo) as HTMLInputElement
        element.checked = true
        items.push(element.value)
      })
    }
    else{
      appState.items.forEach(item => {
        let element = document.getElementById('check-item-' + item.cartonNo) as HTMLInputElement
        element.checked = false
      })
    }
    setSelectItems(items)
  };

  const onCheckChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    console.log('test-check')
    let checked = e.target.checked
    let value = e.target.value
    let element = document.getElementById('check-item-all') as HTMLInputElement
    let items = Object.assign([],selectItems)
    if(checked){
      console.log('check')
        items.push(value)
       
        if(items.length === appState.items.length){
          element.checked = true
          element.indeterminate = false
        }
        else{
          element.checked = false
          element.indeterminate = true
        }
        
    }
    else{
      console.log('uncheck')
      let index = items.indexOf(value);
      if (index > -1) {
        console.log(index)
        items.splice(index, 1);
      }

      if(items.length === 0){
        element.checked = false
        element.indeterminate = false
      }
      else{
        element.checked = false
        element.indeterminate = true
      }
    }

    console.log(items)
    setSelectItems(items)
  }


  const searchData = async () => {
    let field = dataForm.getFieldsValue()
    console.log(field)
    let parameter = InitHelper.InitialParameter();
        parameter.requesters =  []
        parameter.owners = []
        parameter.userConfidential = user.employeeId
        parameter.requesterOrgUnit = user.orgUnit
        parameter.employeeLevel = user.level
    
    let checkConfidential = false
    let requestConfidential = 0
    let ownerConfidential = 0

        if (field.requestNo) {
            parameter.requestNoList = field.requestNo.trim().split(",")
        }

        if(requestStartDate && requestEndDate){
            parameter.requestStartDate = requestStartDate
            parameter.requestEndDate = requestEndDate
        }
        
    if(documentStartYear && documentEndYear){
        parameter.documentStartYear = documentStartYear
        parameter.documentEndYear = documentEndYear
    }

    if(requesters.length > 0){
      checkConfidential = true
      requestConfidential = requesters.filter(x => x.key == user.employeeId).length
      parameter.requesters = requesters.map(item => item.key)
    }

    if(owners.length > 0){
      checkConfidential = true
      ownerConfidential = owners.filter(x => x.key == user.employeeId).length
        parameter.owners = owners.map(item => item.key)
    }
   
    if(checkConfidential && requestConfidential === 0 && ownerConfidential === 0){
      parameter.userConfidential = ""
    }
    
   
    let elementStart = document.getElementById('cartonNoStart') as HTMLInputElement
    let elementEnd = document.getElementById('cartonNoEnd') as HTMLInputElement
    let cartonNoStart = ""
    let cartonNoEnd = ""
    if(elementStart){
      cartonNoStart = elementStart.value
    }
    if(elementEnd){
      cartonNoEnd = elementEnd.value
    }

    if(cartonNoStart && cartonNoEnd){
      parameter.cartonNo = cartonNoStart + '&' + cartonNoEnd
    }

    if(field.cartonNoList){
      parameter.cartonNo = field.cartonNoList
    }

    if(field.cartonNo){
      parameter.cartonNo = field.cartonNo
    }

    console.log(parameter)
    setSelectItems([])
    setRequestTypeId(field.requestTypeId)
    getData(1, appState.perpage, parameter)
    
  }
  const reset = () => {
    let elementStart = document.getElementById('cartonNoStart') as HTMLInputElement
    let elementEnd = document.getElementById('cartonNoEnd') as HTMLInputElement
    elementStart.value = ""
    elementEnd.value = ""

    dataForm.resetFields()
    setRequesters([])
    setOwners([])
    setDocumentStartYear(undefined)
    setDocumentEndYear(undefined)
    setRequestStartDate(null)
    setRequestEndDate(null)
    
    let parameter = InitHelper.InitialParameter()
    parameter.requesters = []
      parameter.owners = []
      parameter.requesterOrgUnit = user.orgUnit
      parameter.employeeLevel = user.level
      parameter.userConfidential = user.employeeId
    getData(1,appState.perpage,parameter)
  }

  const getData = async (currentPage: number,perpage: number , _parameter:Parameter | null = null) => {
    let _state:AppState = Object.assign({},appState)
       _state.isLoading = true
       setAppState(_state)

    let parameter = Object.assign({},saveParameter)
    if(_parameter !== null){
        parameter = _parameter;
    }

    parameter.page = currentPage
    parameter.limit = perpage
    parameter.statusIds = [CartonStatus.Done]
   
    console.log(parameter)

      let token = await getToken()

      let result:any = null
      if(props.requestTypeId === CartonStatus.Collect){
        parameter.cartonStatusIds = [CartonStatus.Collect]
        result = await new CollectCartonService(token).SearchRemoveRequest(parameter)
      }
      if(props.requestTypeId === CartonStatus.Storage){
        parameter.cartonStatusIds = [CartonStatus.Storage]
        result = await new StorageCartonService(token).SearchRemoveRequest(parameter)
      }
      
      console.log(result)
      if(result && result.success)
      {
        let {page,limit,total,items,itemNoList} = result.data
        let removeItems = props.items.map(x => x.cartonNo)
        let dataItems:CartonList[] = items
        let state = Object.assign({},appState)
          state.total = total
          state.currentPage = page
          state.perpage = limit
          state.items = dataItems.filter( x => removeItems.indexOf(x.cartonNo) == -1)
          state.itemNoList = itemNoList
          state.isLoading = false


        setTimeout(() => {
            setSaveParameter(parameter)
            setAppState(state)
        }, 500);
      }
      else{
        let state = Object.assign({},appState)
          state.isLoading = false
          setAppState(state)
      }

  }

    const getToken = async () => {
        const acc = accounts && accounts.length ? accounts[0] : null;
        apiRequest.scopes[0] = "api://" + secureLocalStorage.getItem('clientId') + "/read_user_profile"
        if (acc) {
            const { accessToken: token } = await instance.acquireTokenSilent({
                account: acc,
                scopes: apiRequest.scopes
            });
            return token;
        }
        return ""
    }

  const onPageChange = (page:number,perpage:number) => {
   

    if(perpage !== appState.perpage){
        getData(1,perpage)
    }
    else{
      getData(page,appState.perpage)
    }
  }


const onRequesterSelect = (item:any) => {
  setRequesters(item)
}

const onOwnerSelect = (item:any) => {
    setOwners(item)
  }

const onSearchEmployee = async(key:string) => {
 
  let token = await getToken()
  let result = await new HrWebService(token).SearchEmployee(key)
  if(result && result.success)
  {
    
    let _orgUnit = user.orgUnit
    if(user.orgUnit.indexOf("/") > -1) {
        _orgUnit = user.orgUnit.split("/")[0]
    }
    return result.data.filter(x => x.orgUnit.trim().indexOf(_orgUnit.trim()) > -1)
    
  }
  else{
    console.log(result?.message)
    return []
  }
}

const onDocumentStartYearChange = (value: any) => {
    let year = parseInt(dayjs(value).format('YYYY'))
    setDocumentStartYear(year)
}
  
  const onDocumentEndYearChange = (value: any) => {
    let year = parseInt(dayjs(value).format('YYYY'))
    setDocumentEndYear(year)
}

const onRequestStartDateChange = (date: any) => {
    setRequestStartDate(date);
  }

  const onRequestEndDateChange = (date: any) => {
    setRequestEndDate(date)
  }

  const onRequestTypeIdChange = (value:number) => {
    setRequestTypeId2(value)
  }

  const handleAdd =() => {
    
    props.onSelect(selectItems)
   
 }

 const handleAddCancel =() => {
    
  props.onSelect([])
 
}
 
  return (

    <div>
      <Collapse>
        <Panel header="Carton Search" key="1">
          <Form
            {...layout}
            form={dataForm}
            name="remove-form"
            onFinish={onFinish}
            labelAlign="left"
            colon={false}
            labelWrap={true}
          >
            <Row>
              <Col md={11} >
                <Form.Item name="cartonRange" label="Carton No:(Range)" >
                  <Input className='display-none'/>
                  <table className='w100c'>
                        <tr>
                          <td>
                            <input id="cartonNoStart" className='form-control form-control-sm' placeholder='ex. 03PCS001'/>
                          </td>
                          <td>
                            <Label className='margin-left-10 margin-right-5'>To</Label>
                          </td>
                          <td>
                            <input id="cartonNoEnd" className='form-control form-control-sm' placeholder='ex. 03PCS001'/>
                        
                          </td>
                        </tr>
                      </table>
                </Form.Item>
              </Col>
              <Col md={2} ></Col>
              <Col md={11} >
                <Form.Item name="requestTypeId" label="Carton Status" initialValue={props.requestTypeId}>
                  <Select 
                   disabled
                  onChange={onRequestTypeIdChange}
                    options={[
                      { value: CartonStatus.Collect, label: 'Collect' },
                      { value: CartonStatus.Storage, label: 'Storage' },
                     
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                <Form.Item name="cartonNoList" label="Carton No (Multiple)" >
                  <Input.TextArea placeholder='ex. 03PCS001,03PCS002,03PCS003' rows={5} />
                </Form.Item>
                <Form.Item name="cartonNo" label="Carton No" >
                  <Input placeholder='ex. 03PCS001'/>
                </Form.Item>
                <Form.Item name="requestNo" label={ requestTypeId2 === CartonStatus.Collect ? 'Collect Request No.' : 'Storage Request No.'} >
                      <Input placeholder="ex. B230001,B230002,B230003" />
                    </Form.Item>
              </Col>
              <Col md={2} ></Col>
              <Col md={11} >
              <Form.Item name="documentyear" label="Document Year">
                  <table className='w100c'>
                    <tr>
                      <td>
                        <DatePicker 
                          placeholder={MessageCommon.TitleDate} 
                          picker='year' className='w100c' 
                          onChange={onDocumentStartYearChange}
                        />
                      </td>
                      <td>
                        <Label className='margin-left10 margin-right10 vertical-align-top'>To</Label>
                      </td>
                      <td>
                        <DatePicker 
                          placeholder={MessageCommon.TitleDate} 
                          picker='year' 
                          className='w100c'
                          onChange={onDocumentEndYearChange}
                        />
                      </td>
                    </tr>
                  </table>
                </Form.Item>
                <Form.Item name="requester" label="Requester" >
                   <EmployeeAutoComplete
                     placeholder='Search by Name'
                    selectedItems={requesters ? requesters : []}
                    onChange={item => onRequesterSelect(item)}
                    service={onSearchEmployee}
                    minimumTextLength={3}
                  />
                </Form.Item>
                <Form.Item name="owner" label="Owner" >
                   <EmployeeAutoComplete
                     placeholder='Search by Name'
                    selectedItems={owners ? owners : []}
                    onChange={item => onOwnerSelect(item)}
                    service={onSearchEmployee}
                    minimumTextLength={3}
                  />
                </Form.Item>
                
                <Form.Item name="requestDate" label={ requestTypeId2 === CartonStatus.Collect ? 'Collect Request Date' : 'Storage Request Date'}>
                      <table className='w100c'>
                        <tr>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate} format={'DD MMM YYYY'} className='date-picker-full' onChange={onRequestStartDateChange}/>
                          </td>
                          <td>
                            <Label className='margin-left-10 margin-right-10'>To</Label>
                          </td>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate} format={'DD MMM YYYY'} className='date-picker-full' onChange={onRequestEndDateChange}/>
                          </td>
                        </tr>
                      </table>
                    </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
              
               
              </Col>
              <Col md={2} ></Col>
              <Col md={11} >
              
              </Col>
            </Row>
        
          </Form>
          <div className='text-center'>
            <Button type="default" className='mr-btn' onClick={reset} >
              <AiOutlineSync className='icn-btn' /> Reset
            </Button>
            <Button type="primary" onClick={searchData}  >
              <AiOutlineSearch className='icn-btn' /> Search
            </Button>


          </div>

        </Panel>
      </Collapse>


      <br></br>
      <Collapse defaultActiveKey={['1']}>
        <Panel header="Data Result" key="1" >
          
          <div className='float-left'>
          <Button type="primary" className='btn-blue mr-btn w100' onClick={handleAdd} disabled={selectItems.length === 0}>
            <AiOutlineFileAdd className='icn-btn' /> Add
          </Button>
          <Button type="default" className='mr-btn' onClick={handleAddCancel}  >
            <AiOutlineCloseCircle className='icn-btn' />Cancel
          </Button>
        </div>
          <div className='float-right'>
            
          </div>
          <br></br>
          <br></br>
          <div id="table-container">
        { appState.isLoading ?
            <div className='margin-auto padding-bottom-30'>
              <Spin tip="Loading" size="large">
                <div className="content" />
              </Spin>
            </div>
          :
          <table className='idoc-table'>
            <thead id="head-table-fixed">
              <tr>
                <th className='text-left w50'>
                { appState.items.length > 0 ?
                  <div className="form-check">
                    <input  type="checkbox" id={'check-item-all'} className="form-check-input check-item" onChange={(e) => onCheckAll(e)}/>
                    <label className="form-check-label" htmlFor={'check-item-all'}/>
                  </div>:<></>
                }
                </th>
                <th >Carton No.</th>
                <th >{ requestTypeId === CartonStatus.Collect ? 'Collect Requested No.' : 'Storage Request No.' }</th>
                <th >Requested Date</th>
                <th >Requester</th>
                <th >Owner</th>
                { requestTypeId === CartonStatus.Collect ?
                    <th >Collect By</th>:<></>
                }
                <th >Carton Status</th>
                <th>Detail</th>
              </tr>
            </thead>
           
            <tbody >
            { appState.items.map((item:CartonList) => (
                <tr>
                   <td className='text-center w50'>
                      <div className="form-check">
                          <input  type="checkbox" id={'check-item-' + item.cartonNo} value={item.cartonNo} className="form-check-input check-item" onChange={(e) => onCheckChange(e)}/>
                          <label className="form-check-label" htmlFor={'check-item-' + item.cartonNo}/>
                        </div>
                  </td>
                  <td className='text-center w120'>
                   {item.cartonNo}
                  </td>
                  <td className='text-center'>
                   {item.requestNo}
                  </td>
                  <td className='text-center'>{item.requestDate ? dayjs(item.requestDate).format("DD MMM YYYY") : ""}</td>
                  <td className='text-center'>{item.requesterName}</td>
                  <td className='text-center'>{item.ownerName}</td>
                 
                  { requestTypeId === CartonStatus.Collect ?
                        <td className='text-center'>{item.collectByName}</td>:<></>
                  }
                  <td className='text-center'>{item.cartonStatus}</td>
                  <td className='text-center'>
                    { requestTypeId === CartonStatus.Collect ?
                        <a onClick={() => handleOpenModalRequest(item.collectRecordNo)}>
                            <AiFillEye className='icon-table'></AiFillEye>
                        </a>
                        :
                        <a onClick={() => handleOpenModalRequest(item.storageRecordNo)}>
                            <AiFillEye className='icon-table'></AiFillEye>
                        </a>
                    }
                  </td>
                 
                </tr>
              ))
            }
            
            </tbody>
  
          </table>
        }
          </div>
          <div className='margin-top-10 text-right'>
          { appState.total > 0 ?
                <Pagination 
                key={Helper.Uniqid()}
                current={appState.currentPage} 
                pageSize={appState.perpage}
                total={appState.total} 
                onChange={onPageChange} 
                pageSizeOptions={pageSizeOptions}
                showSizeChanger={true}
              />:<></>
          }
          </div>
        </Panel>
      </Collapse>
      <Modal title="Carton Detail" open={isModalOpen} footer={''}  width={1550} onCancel={handleCancel} maskClosable={false}>
        { requestTypeId2 === CartonStatus.Collect ?
          <RemoveCartonModalCollect key={Helper.Uniqid()} removeId={0} items={selectItems} page="remove" onReload={null}/>:<></>
        }
        { requestTypeId2 === CartonStatus.Storage ?
          <RemoveCartonModalStorage key={Helper.Uniqid()} removeId={0} items={selectItems} page="remove" onReload={null}/>:<></>
        }
      </Modal>

        <Modal title="Request Detail" open={isModalRequestOpen} footer={''} width={1550} onCancel={handleCancelModalRequest}>
        { requestTypeId2 === CartonStatus.Collect ?
          <CollectCartonRequestDetail key={Helper.Uniqid()} recordNo={recordNo}/>
          :
                  <StorageCartonRequestDetail key={Helper.Uniqid()} recordNo={recordNo} cartonNumber={""} approveLevel={0}/>
        }
          </Modal>
          {modal ? <span></span> : <></>}
      {contextHolder}
    </div>
  );

}

export default RemoveCartonAdd
